import apiClient from 'services/httpClient'
import { API_ENDPOINTS } from 'shared/constants/apiEndpoints'

/**
 * Notification service.
 *
 * Implements: Requirements 17.3, 17.4, 17.5
 *
 * Backend surface:
 *   - GET    /notifications?page=&limit=
 *       returns { items, page, limit, total, unreadCount }
 *   - GET    /notifications/unread-count
 *       returns { unreadCount }
 *   - PATCH  /notifications/:id/read
 *       returns { id, alreadyRead }
 *
 * The shared `apiClient` already unwraps the `{ success, data }` envelope
 * and resolves with `data` directly, so callers receive the inner payload.
 */

export const getNotifications = ({ page, limit } = {}) => {
    const params = {}
    if (page !== undefined && page !== null) params.page = page
    if (limit !== undefined && limit !== null) params.limit = limit
    return apiClient.get({
        url: API_ENDPOINTS.notifications.list,
        params,
    })
}

export const getNotificationUnreadCount = () => {
    return apiClient.get({ url: API_ENDPOINTS.notifications.unreadCount })
}

export const markNotificationAsRead = (notificationId) => {
    return apiClient.patch({
        url: API_ENDPOINTS.notifications.markRead(notificationId),
    })
}
